import { defineComponent as _defineComponent } from 'vue'
import { computed, onUpdated, ref } from 'vue';
import Modal from '@/components/Modal.vue';
import store from '@/store';
import { ISystem } from '@/store/base';

export default /*#__PURE__*/_defineComponent({
  __name: 'DDos',
  setup(__props) {

const seconds = ref(0)
const timerId = ref(0)
const setDDos = (data?: ISystem) => {
  store.commit('setDDos', data);
}
const getCount = computed(() => {
  const timer = new Date(seconds.value)
  const min = timer.getMinutes();
  const sec = timer.getSeconds();
  return `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
})
const isDDos = computed(() => store.getters.isDDos)
const getTextSeconds = computed(() => store.getters.getTextSeconds)

const close = () => {
  setDDos();
}
const countDown = (count: number) => {
  if (count) {
    count *= 1000;
    clearTimeout(timerId.value)
    seconds.value = count //- 1000;
    const go = () => {
      if (seconds.value > 0) {
        seconds.value -= 1000;
        timerId.value = setTimeout(go, 1000);
      }
    }

    setTimeout(go, 1000);
  }
}

onUpdated(() => {
  countDown(getTextSeconds.value)
})

return { __sfc: true,seconds, timerId, setDDos, getCount, isDDos, getTextSeconds, close, countDown, Modal }
}

})